import { useEffect, useState } from 'react';
import './styles.scss';

export const ImgImporter: React.FC<{ path: string; alt?: string; className?: string }> = ({
  path,
  alt = 'img',
  className = ''
}) => {
  const [image, setImage] = useState<string>('');
  useEffect(() => {
    (async () => {
      try {
        const response = await import(`../../assets/images/${path}`);
        setImage(response?.default);
      } catch (err) {
        setImage('');
      }
    })();
  }, [path]);
  return image ? <img className={`image_block ${className}`} src={image} alt={alt} /> : <></>;
};
